
<ng-container *ngIf="!isAdmin; else adminTitle">
  <h2>Forgot Your Password?</h2>
  <p>
    Enter your email address and we'll send you an email to reset your password.
  </p>
</ng-container>
<ng-template #adminTitle>
  <p>Send reset password email to <strong>{{emailAddress.value}}?</strong></p>
</ng-template>

<form
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="text-left mt-4"
  data-testid="request-password-reset-form">
    <div *ngIf="!isAdmin" class="form-group">
        <input
          [formControl]="emailAddress"
          class="form-control validation-field"
          placeholder="Email Address"
          type="email"
          autocomplete="username"
          #emailAddressField
        data-testid="request-password-reset-email-address-email">
        <small
          class="text-danger"
          *ngIf="form.get('emailAddress').touched && form.get('emailAddress').hasError('required')"
        >
            Email Address is required
        </small>
    </div>

    <div
      *ngIf="message"
      class="success-message"
      role="alert"
    >
      {{message}}
    </div>

    <div class="error-message" role="alert" *ngIf="errorMessage">
        <div class="d-flex flex-nowrap">
            <span class="fa fa-exclamation-triangle align-self-center mx-2"></span>
            <span class="mx-1">{{errorMessage}}</span>
            <span class="fa fa-exclamation-triangle align-self-center mx-2"></span>
        </div>
    </div>

    <div class="form-group">
        <button
          [disabled]="!form.valid || isLoading"
          class="btn btn-primary btn-block" type="submit"
          data-testid="request-password-reset-wait">
          <span *ngIf="isLoading">Please wait...</span>
          <span *ngIf="!isLoading">Send Password Reset Email</span>
        </button>
    </div>
</form>



// WEBPACK FOOTER //
// ./src/app/auth/forgot-password/request-password-reset/request-password-reset.component.html